export default __webpack_public_path__ + "static/media/accountBannerMB.f70bad54.png";